// The source step: the source cards, the secret, the GitHub and Asana filters, the refresh
// cadence, the repositories and the test of the filter.
import { plural } from "../../../../helpers";

const p = plural("en");

export default {
  source: {
    label: "Sources",
    hints: {
      manual: "You add tasks yourself, from the app.",
      github: "Open issues of a repository, by label or assignee.",
      jira: "Issues a Jira query selects, built here step by step.",
      asana: "Incomplete tasks of an Asana project or section.",
    },
    manualNote: "Tasks are added by hand from the iPhone or Android app. Nothing is polled.",
    connect: "Connect",
    connectWith: (source: string) => `Secret to read ${source} with`,
    noSecret: (source: string) => `You have no secret that can read ${source} yet.`,
    whichIssues: "Which issues become tasks",
    filter: "Which items become tasks",
    testNeedsSecret: "Choose a secret above to test against the real source.",
    testNeedsFilter: "Complete the filter above to test it.",
  },
  cadence: {
    label: "Check for new tasks",
    hint: "New matches become tasks; items closed upstream cancel their queued tasks.",
    presets: { 5: "Every 5 min", 15: "Every 15 min", 60: "Hourly", 1440: "Daily" },
    custom: "Custom",
    minutes: "Minutes between checks",
    minutesSuffix: "min",
    range: "1 to 1,440",
  },
  github: {
    repo: "Repository",
    repoHint: "owner/name. Its open issues become tasks; pull requests never do.",
    labels: "Labels",
    labelsHint: "Comma-separated; an issue needs all of them.",
    assignee: "Assignee",
    assigneeHint: "A login, none (unassigned) or * (anyone assigned).",
    includeClosed: "Watch closed issues too",
    includeClosedHint: "Lets the group cancel a queued task as soon as its issue closes.",
  },
  asana: {
    project: "Project id",
    projectHint: "The digits in the project's URL.",
    section: "Section id",
    sectionHint: "Optional: only tasks in this section.",
  },
  repositories: {
    title: "Repositories to clone",
    description: "Cloned into the workspace for the agent, besides a GitHub source's own repository.",
    add: "Add repository",
    advice: "This workflow works on GitHub, but no repository is listed: the agent would have no code to work on.",
    repo: (n: number) => `Repository ${n}`,
    branch: (n: number) => `Branch of repository ${n}`,
    branchPlaceholder: "Branch (default main)",
    remove: (n: number) => `Remove repository ${n}`,
    problems: {
      tooMany: "At most 10 repositories.",
      repo: "Use owner/name.",
      branch: "Not a valid branch name.",
      duplicate: "Another repository is cloned under this name.",
    },
  },
  preview: {
    title: "Test it",
    description: "See what the source returns right now, as the group will. Nothing is saved.",
    run: "Test query",
    again: "Test again",
    none: "Nothing matches yet",
    noneBody: "That can be right: new matches become tasks when the group checks.",
    matches: (n: number, complete: boolean) => (complete ? p(n, { one: "# item matches", other: "# items match" }) : `More than ${n} items match`),
    firstItems: "First matching items",
    open: "Open",
    closed: "Closed",
    openItem: (ref: string) => `Open ${ref} in a new tab`,
    more: (n: number) => p(n, { one: "and # more", other: "and # more" }),
    failed: "The source refused the query",
    stale: "Changed since the last test.",
  },
};
